import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { transChannel, transRegion } from '@/pages/opinion/utils';
import { getLocale, useHistory } from 'umi';
import './index.scss';
import videoDefaultImg from '@/pages/opinion/assets/imgs/post-default-img.jpg';
import logoDatabrain from '@/pages/opinion/assets/svg/logo-databrain.svg';
import logoLevel from '@/pages/opinion/assets/svg/logo-level-infinite.svg';
import {
  getNewsContentText,
  getFeedsTitleText,
  getFeedsTopicEle,
} from '@/pages/opinion/utils/languageValue';
import RenderImg from '@/pages/opinion/components/RenderImg';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import CardCommon from '@/pages/opinion/components/CardCommon';
import NewsModal from '../NewsModal';
import { dealwithBiLiBiLiImage } from '@/pages/opinion/utils/cdnUrl';
import { useNewsInfo } from '../../hooks/useNewsInfo';
import { Segment } from 'tea-component';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';
import SentimentEditBox from '@op/components/SentimentEditBox';
import ChannelLabel from '@op/components/ChannelLabel';

import appfamitsuIcon from '@op/assets/svg/appfamitsu-icon.svg';
import CommonBubble from '@home/components/CommonBubble';
import FilterBoxCommon from '@op/components/FilterBoxCommon';
import { LanguageType } from '@op/types/common';
import useLanguage from '@op/hooks/useLanguage';
import { newsHotTabTips } from '@op/components/BubbleCommon';

export default function RecentTopNews({ params }: any) {
  const [records, setRecords] = useState<any>([]);
  const locale = getLocale();
  const [languageType, setLanguageType] = useState<LanguageType>('en');
  const [tab, setTab] = useState<'engagement' | 'release_time'>('release_time');
  const { formatMessage, formatOptionsMessage } = useLanguage();

  const realParams = useMemo(() => {
    return { ...params, sort_item: tab, sort_model: 'desc' };
  }, [tab, params]);

  const { list, loading, deleteNews } = useNewsInfo({
    params: realParams,
    beginRequest: () => {
      setRecords([]);
    },
    otherParams: {
      channel_type: 'news',
      page: 1,
      page_size: 3,
      translated_to: 'origin',
      need_topic_translation: true,
    },
  });

  const [visible, setVisible] = useState(false);
  const [newsItem, setNewsItem] = useState<any>({});

  useEffect(() => {
    if (list?.length > 0 && list[0].md5_uni) {
      const newArray: Array<any> = [];
      const keyMap: any = {
        en: {
          titleKey: 'title_en',
          contentKey: 'content_en',
          topicKey: 'topic_en',
        },
        cn: {
          titleKey: 'title_cn',
          contentKey: 'content_cn',
          topicKey: 'topic_cn',
        },
        origin: {
          titleKey: 'news_title',
          contentKey: 'content',
          topicKey: 'topic',
        },
      };
      const { titleKey, contentKey, topicKey } =
        keyMap[languageType] || keyMap['origin'];

      list.forEach((item: { [x: string]: any }) => {
        newArray.push({
          ...item,
          news_title: item[titleKey],
          content: item[contentKey],
          news_topic: item[topicKey],
        });
      });

      setRecords(newArray);
    }
  }, [languageType, list]);

  const history = useHistory();
  const goToFeedsPage = (value?: string) => {
    // 先简单处理
    const url = '/opinion/Feeds/Feeds?tab=newMedia';
    history.push(url, { search: value, languageType: 'en', sort_item: tab });
  };

  return (
    <>
      <NewsModal
        visible={visible}
        data={newsItem}
        languageType={languageType}
        close={() => {
          setNewsItem({});
          setVisible(!visible);
        }}
      />
      <CardCommon
        className="dbo-news-recent"
        title={formatMessage({ id: 'News' })}
        hasTitleArrow
        handleTitleOnClick={goToFeedsPage}
      >
        {/* 多语言筛选 */}
        <FilterBoxCommon
          left={[
            {
              key: 'pos',
              element: (
                <Segment
                  className={`card-slot-segment`}
                  value={tab}
                  onChange={(value: any) => setTab(value)}
                  options={formatOptionsMessage(
                    [
                      { text: 'Latest', value: 'release_time' },
                      {
                        text: 'Hot-2',
                        value: 'engagement',
                        tips: newsHotTabTips,
                      },
                    ],
                    undefined,
                    { showIcon: false, placement: 'top' },
                  )}
                />
              ),
            },
            { key: 'language', defaultValue: languageType },
          ]}
          right={[
            {
              key: 'search',
              defaultParams: {
                placeholder: formatMessage({
                  id: 'Search news headline by original keyword or phrase',
                }),
                onSearch: (value: string) => goToFeedsPage(value),
                style: { width: '420px' },
              },
            },
          ]}
          onChange={(value: any, key) => {
            if (key === 'language') {
              setLanguageType(value.language || 'origin');
            }
          }}
        ></FilterBoxCommon>
        <CardCommon
          empty={records?.length === 0}
          emptyHeight={546}
          contentCard
          loading={loading}
          loadingHeight={546}
        >
          <div className="dbo-news-recent-body">
            {records?.map((e: any) => {
              const textChannel = transChannel(e.source);

              return (
                <div
                  className="dbo-news-item"
                  key={e.md5_uni}
                  onClick={() => {
                    setNewsItem(e);
                    setVisible(true);
                  }}
                >
                  <RenderImg
                    className="dbo-news-item-left"
                    coverImage={dealwithBiLiBiLiImage(e.cover)}
                    defaultImage={videoDefaultImg}
                  ></RenderImg>
                  <div className="dbo-news-item-right">
                    <div>
                      <CommonBubble
                        overlayClassName="dbo-scroll-bubble"
                        content={
                          <div className="dbo-scroll-bubble-scroll">
                            {getFeedsTitleText(e, languageType)}
                          </div>
                        }
                      >
                        <div className="dbo-news-item-right-title">
                          {getFeedsTitleText(e, languageType)}
                        </div>
                      </CommonBubble>
                      <CommonBubble
                        overlayClassName="dbo-scroll-bubble"
                        content={
                          <div className="dbo-scroll-bubble-scroll">
                            {getNewsContentText(e, languageType)}
                          </div>
                        }
                      >
                        <div className="dbo-news-item-right-text">
                          {getNewsContentText(e, languageType)}
                        </div>
                      </CommonBubble>
                      <div className="dbo-news-item-right-desc">
                        <div className="dbo-text-item">
                          <SentimentEditBox
                            data={e}
                            needRequest
                            realValue={e.sentiment_rating}
                            type="news"
                          ></SentimentEditBox>
                          {moment(e.release_time).format('YYYY-MM-DD')}
                        </div>
                        {e.source && (
                          <div className="dbo-text-item">
                            <ChannelLabel
                              showText={false}
                              className="dbo-news-icon"
                              channel_name={textChannel}
                              defaultImage={appfamitsuIcon}
                            ></ChannelLabel>
                            {transChannel(e.source)}
                          </div>
                        )}
                        {e.market && (
                          <div className="dbo-text-item">
                            {/* 这里是RegionCountryItem 组件渲染 */}
                            <RegionCountryItem
                              showText={false}
                              market={e.market}
                            ></RegionCountryItem>
                            {e.news_language && (
                              <div className="dbo-text-item-text">
                                {transRegion(
                                  e.news_language,
                                  locale === 'en-US' ? 3 : 6,
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {e.visit_number > 0 && (
                          <div className="dbo-text-item">
                            <img
                              src={logoLevel}
                              className="dbo-text-item-logo"
                            />
                            {reviewsFormat(e.visit_number)}{' '}
                            {formatMessage({ id: 'Reach' })}
                          </div>
                        )}
                        {e.engagement > 0 && (
                          <div className="dbo-text-item">
                            <img
                              src={logoDatabrain}
                              className="dbo-text-item-logo"
                            />
                            {reviewsFormat(e.engagement)}{' '}
                            {formatMessage({ id: 'Engagement' })}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="dbo-news-item-right-tag">
                      {getFeedsTopicEle(e, languageType)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardCommon>
      </CardCommon>
    </>
  );
}
